import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "c-form-control-checkbox__label",
  for: "schlusserklaerungMakler2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_steps = _resolveComponent("steps")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_icon_sprite = _resolveComponent("icon-sprite")!
  const _component_abschluss = _resolveComponent("abschluss")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_steps, {
      items: _ctx.navItems,
      active: 3,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createVNode(_component_abschluss, {
      produkt: "vhv2024",
      "zeige-versichertes-objekt": true,
      "zeige-tarif": true,
      "zeige-angaben-bestaetigen": !_ctx.piniaStore.state.isMakler,
      onNextPage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('next-page', $event))),
      onGotoPage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, _createSlots({
      "versichertes-objekt": _withCtx(() => [
        _createElementVNode("strong", null, "Versicherungssumme: " + _toDisplayString(_ctx.formatCurrency(_ctx.piniaStore.state.tarifinformationen.versicherungssumme, 0)), 1),
        _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" Wohnfläche: " + _toDisplayString(_ctx.piniaStore.state.gebaeudedaten.wohnflaeche) + " m2, Wohnort: " + _toDisplayString(_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.plz) + " " + _toDisplayString(_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.ort) + ", " + _toDisplayString(_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.strasse) + " " + _toDisplayString(_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.hausnummer) + " " + _toDisplayString(_ctx.gebaeudetypText), 1)
      ]),
      _: 2
    }, [
      (_ctx.listeDerZusatzmodule)
        ? {
            name: "zusatzmodule",
            fn: _withCtx(() => [
              _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.listeDerZusatzmodule), 1)
            ]),
            key: "0"
          }
        : undefined,
      (_ctx.piniaStore.state.tarifinformationen.extraSelbstbeteiligung)
        ? {
            name: "zusaetzliche-selbstbeteiligung",
            fn: _withCtx(() => [
              _createVNode(_component_zeile, { class: "u-mar-t-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, {
                    breite: 3,
                    class: "o-grid__cell--4",
                    "ausrichtung-responsiv": false,
                    "vertikal-zentrieren": false
                  }, {
                    default: _withCtx(() => [
                      _cache[8] || (_cache[8] = _createTextVNode(" Zusätz­liche Selbst­be­teili­gung je Scha­den  ")),
                      _createElementVNode("a", {
                        class: "u-copy-s field-edit",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.geheZuVergleich && _ctx.geheZuVergleich(...args)))
                      }, "bearbeiten")
                    ]),
                    _: 1,
                    __: [8]
                  }),
                  _createVNode(_component_zelle, {
                    breite: 9,
                    class: "o-grid__cell--8",
                    "data-cy": "zusaetzlicheSb"
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createElementVNode("strong", null, "250 €", -1),
                      _createTextVNode(" aufgrund fehlender Vorversicherung ")
                    ])),
                    _: 1,
                    __: [9]
                  })
                ]),
                _: 1
              })
            ]),
            key: "1"
          }
        : undefined,
      (!_ctx.piniaStore.state.isMakler)
        ? {
            name: "angaben-bestaetigen",
            fn: _withCtx(() => [
              _cache[10] || (_cache[10] = _createTextVNode(" Ja, der Antrag wurde gemäß meinen Angaben erstellt. Ich bestätige, dass mein Haus/meine Wohnung ständig bewohnt ist, dass es sich um ein Massiv- oder Fertighaus mit hartem Dach handelt und dass die ")),
              _createElementVNode("a", {
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.wechsleSichtbarkeit('mindestsicherungen')), ["stop","prevent"]))
              }, " tariflichen Mindestsicherungen "),
              _cache[11] || (_cache[11] = _createTextVNode(" erfüllt sind.Auf eine Beratung habe ich verzichtet und damit auf den Schadenersatzanspruch nach §6. Abs. 5 VVG. "))
            ]),
            key: "2"
          }
        : undefined,
      (_ctx.piniaStore.state.isMakler)
        ? {
            name: "schlusserklaerungMakler2",
            fn: _withCtx(() => [
              _cache[13] || (_cache[13] = _createElementVNode("input", {
                type: "checkbox",
                class: "c-form-control-checkbox__input",
                id: "schlusserklaerungMakler2",
                name: "schlusserklaerungMakler2",
                required: "",
                "aria-required": "true",
                "aria-label": "Ja, der Antrag wurde gemäß meinen Angaben erstellt.",
                "data-fehlermeldung": "Bitte bestätigen Sie die Erklärung.",
                "data-cy": "schlusserklaerungMakler2"
              }, null, -1)),
              _createElementVNode("label", _hoisted_1, [
                _createVNode(_component_icon_sprite, {
                  "icon-name": "icon-check-mark",
                  "css-klassen": "c-form-control-checkbox__icon",
                  "ist-klein": true
                }),
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "c-form-control-checkbox__label-text" }, " Ja, der Antrag wurde gemäß meinen Angaben erstellt. Der/die Versicherungsmakler/in bestätigt stellvertretend im Auftrage seines Mandanten, dass mein Haus/meine Wohnung ständig bewohnt ist und dass die tariflichen Mindestsicherungen erfüllt sind. ", -1))
              ])
            ]),
            key: "3"
          }
        : undefined
    ]), 1032, ["zeige-angaben-bestaetigen"]),
    (_ctx.istSichtbar('mindestsicherungen'))
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          id: "mindestsicherungen",
          titel: "Tarifliche Mindestsicherungen",
          text: "Unter einer Mindestsicherung der Wohnung versteht die GEV die Sicherung von Haustüren bzw. Wohnungsabschlusstüren durch ein Zylinderschloss mit Sicherheitsbeschlag (von außen nicht abschraubbar und über bündig montierte – max. 5 mm überstehende – Schließzylinder). Gleiches gilt für die Sicherung von weiteren Außentüren (z.B. Terrassen-, Kellertüren). Trifft das nicht zu, kontaktieren Sie uns bitte unter 040 3766 3366.",
          onCloseModal: _cache[5] || (_cache[5] = ($event: any) => (_ctx.wechsleSichtbarkeit('mindestsicherungen')))
        }))
      : _createCommentVNode("", true)
  ], 64))
}